import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersConversation {
  @service conversationLifecycle;
  @service messagingLogging;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(response) {
    const statusHandlers = {
      updated: payload => this.conversationLifecycle.apply(payload),
      left: payload => this.conversationLifecycle.apply(payload, { notify: false }),
      read: payload => this.conversationLifecycle.markAsRead(payload),
      replace: payload =>
        this.conversationLifecycle.replace(payload.replacedConversationId, payload.newConversation),
      destroyed: payload => this.conversationLifecycle.remove(payload.conversation_id),
    };
    const handler = response.status ? statusHandlers[response.status] : null;

    if (!handler) {
      this.messagingLogging.warn('Unhandled websocket conversation activity status', {
        action: 'conversation',
        status: response.status,
      });
      return;
    }

    return handler(response.payload);
  }
}
